import { AccessPermissionsEnum } from '@/router/constants';

function load(component) {
  return () => import(`@/views/${component}.vue`);
}
export default [
  {
    path: 'statistic',
    name: 'statistic',
    component: load('statistic/Statistic'),
    redirect: {
      name: 'statistic:employee-rating',
    },
    meta: {
      requiresAuth: true,
      accessPermissions: [AccessPermissionsEnum.CAN_READ_STATISTIC],
      menuItems: 'leftSideMenu.statistic',
    },
    children: [
      {
        path: 'satisfaction',
        name: 'statistic:satisfaction',
        component: load('statistic/Satisfaction'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_STATISTIC],
          menuItems: 'leftSideMenu.statistic',
        },
      },
      {
        path: 'average-check',
        name: 'statistic:average-check',
        component: load('statistic/AverageCheck'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_STATISTIC],
          menuItems: 'leftSideMenu.statistic',
        },
      },
      {
        path: 'top-selling',
        name: 'statistic:top-selling',
        component: load('statistic/TopSelling'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_STATISTIC],
          menuItems: 'leftSideMenu.statistic',
        },
      },
      {
        path: 'retention',
        name: 'statistic:retention',
        component: load('statistic/RetentionLevel'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_STATISTIC],
          menuItems: 'leftSideMenu.statistic',
        },
      },
      {
        path: 'transaction',
        name: 'statistic:transaction',
        component: load('statistic/Transaction'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_STATISTIC],
          menuItems: 'leftSideMenu.statistic',
        },
      },
      {
        path: 'employee-rating',
        name: 'statistic:employee-rating',
        component: load('statistic/employeeAnalytics/EmployeeRatingPage'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_STATISTIC],
          roles: ['admin'],
          menuItems: 'leftSideMenu.statistic',
        },
      },
      {
        path: 'employee-rating/:employeeId',
        name: 'statistic:employee-details',
        component: load('statistic/employeeAnalytics/EmployeeDetailsPage'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_STATISTIC],
          roles: ['admin'],
          menuItems: 'leftSideMenu.statistic',
        },
      },
      {
        path: 'employee-rating/:employeeId/check/:checkId',
        name: 'statistic:employee-check-details',
        component: load('statistic/employeeAnalytics/EmployeeCheckDetailsPage'),
        meta: {
          requiresAuth: true,
          accessPermissions: [AccessPermissionsEnum.CAN_READ_STATISTIC],
          roles: ['admin'],
          menuItems: 'leftSideMenu.statistic',
        },
      },
    ],
  },
];
